import { uid, isSameId } from "../helpers";
import { getNextTaskId } from "./task/common";
import { uid as libUid } from "@xbs/lib-state";
export function moveSelectedToProject({ store, id }) {
    const selected = store.getSelection({ sorted: true });
    const batch = selected.filter(t1 => {
        const task1 = store.getTask(t1);
        return !selected.some(t2 => {
            return isSameId(store.getTask(t2).id, task1.parent);
        });
    });
    const historyBatch = libUid();
    for (let index = 0; index < selected.length; index++) {
        const selectedId = selected[index];
        moveToProject(store, id, selectedId, batch, !!index, historyBatch);
    }
}
export function moveToProject(store, branchId, taskId, batch, skipProvider, historyBatch) {
    const task = store.getTask(taskId);
    if (isSameId(branchId, task?.project) || typeof branchId === "undefined")
        return;
    store.in.exec("select-task", {
        id: getNextTaskId({ store, id: taskId }),
    });
    store.in.exec("move-task", {
        id: taskId,
        project: branchId,
        parent: null,
        operation: "project",
        skipProvider,
        batch,
        $meta: {
            batch: historyBatch,
        },
    });
}
export function createProject(store, project) {
    const id = project?.id || uid().toString();
    store.in.exec("add-project", {
        id,
        project: { label: project?.label || "New project" },
    });
    store.in.exec("set-project", { id });
    store.in.exec("open-inline-editor", {
        id,
        type: "project",
    });
}
//# sourceMappingURL=project.js.map